module.exports = __webpack_public_path__ + "img/emptySchools.f3ad961e.png";